<template>
  <div>
    <div class="row-fluid">
      <h4 v-if="!isMobile" class="gfn span6 text-uppercase">{{ guest.full_name }}</h4>
    </div>
    <div class="row-fluid info_allergie" v-if="guest.allergies">
      <div class="warning text-uppercase">
        <div class="allergies">
          <warning-msg :other-class="'alert-error'" :label="i18nJS.allergies_warning" :message="guest.allergies" />
        </div>
      </div>
    </div>
    <div class="row-fluid somm somm-heading">
      <div class="span2">
        <div class="row-fluid">
          <div class="span1"></div>
          <div class="span11">{{ i18nJS.via_somm }}</div>
        </div>
      </div>
      <div class="span3">{{ i18nJS.drug }}</div>
      <div class="span2 done somm_label">
        {{ i18nJS.confirmed_therapy }}
        <br />
        <input type="checkbox" :checked="allDone" ref="checkAll" @click="toggleAllConfirmation" />
      </div>
      <div class="span1 center">{{ i18nJS.dose }}</div>
      <div class="span2">{{ i18nJS.notes }}</div>
      <div class="span2">{{ i18nJS.notes }}</div>
    </div>
    <div v-for="(therapies, hour) in hours" :key="hour">
      <h4>{{ hour }}</h4>
      <div v-for="(therapy, index) in therapies" :class="['row-fluid', 'somm', `barTherapies${index}`]" :key="index">
        <div class="span2">{{ therapy.guest_drug.get_somm_type }}</div>
        <div class="span3">
          <div class="row-fluid">
            <div class="span10">
              <div>
                <a
                  v-if="therapy.drug_id"
                  :href="bugiardinoLink.replace('__DRUG_ID__', therapy.drug_id)"
                  data-target="#bugiardino"
                  data-toggle="modal"
                >
                  {{ therapy.guest_drug.drug_desc }}
                </a>
                <template v-else>
                  {{ therapy.guest_drug.drug_desc }}
                </template>
                <template v-if="therapy.guest_drug.recurring"> ({{ therapy.guest_drug.recurring }}) </template>
              </div>
              <div v-if="therapy.guest_drug.infusion">
                <div v-for="(description, index) in therapy.guest_drug.infusion_description" :key="index">- {{ description }}</div>
              </div>
              <div class="royalblue bugiardino_link" v-if="therapy.guest_drug.descr_principio_attivo">
                {{ therapy.guest_drug.descr_principio_attivo }}
              </div>
              <div class="royalblue bugiardino_link" v-if="therapy.guest_drug.categoria">{{ therapy.guest_drug.categoria }}</div>
              <div
                class="royalblue bugiardino_link"
                v-if="
                  therapy.guest_drug.descr_via_somministrazione ||
                  therapy.guest_drug.descr_forma_farmaceutica ||
                  therapy.guest_drug.get_somm_type ||
                  therapy.guest_drug.get_somm_form
                "
              >
                {{ [therapy.guest_drug.descr_via_somministrazione, therapy.guest_drug.descr_forma_farmaceutica].join(' ') }}
                {{ [therapy.guest_drug.get_somm_type, therapy.guest_drug.get_somm_form].join(' ') }}
              </div>
              <div class="royalblue bugiardino_link" v-if="therapy.guest_drug.prescrittore">
                {{ i18nJS.prescritto_da }}: {{ therapy.guest_drug.prescrittore }}
              </div>
              <div class="warning" v-if="therapy.guest_drug.notes_and_coumadin_notes">
                {{ i18nJS.notes }}: {{ therapy.guest_drug.notes_and_coumadin_notes }}
              </div>
              <template v-if="therapy.guest_drug.ab && therapiesAbConstraintsEnabled">
                <template v-if="therapy.guest_drug.qta_max_gg_s"> {{ i18nJS.qta_max_gg }}: {{ therapy.guest_drug.qta_max_gg_s }} </template>
                <template v-if="therapy.guest_drug.time_range">
                  <br />
                  {{ i18nJS.time_range }}: {{ therapy.guest_drug.time_range }}
                </template>
                <template v-if="therapy.guest_drug.condizione_ab">
                  <br />
                  {{ i18nJS.condizione_ab }}: {{ therapy.guest_drug.condizione_ab }}
                </template>
              </template>
            </div>
          </div>
        </div>
        <template v-if="therapy.can_edit">
          <div class="span2 done center">
            <input type="checkbox" v-model="therapy.confirmed" @change="() => toggleConfirmation(therapy)" />
          </div>
          <div class="span1 center">{{ therapy.qta_s }}</div>
          <div class="span2">
            <textarea
              v-if="therapy.id"
              v-model="therapy.notes"
              rows="1"
              class="input-block-level"
              @focusout="() => toggleConfirmation(therapy)"
            />
            <div class="bugiardino_link royalblue">{{ therapy.guest_drug.before_after_meal }}</div>
          </div>
        </template>
        <template v-else>
          <div class="span2 center">
            <fa-icon v-if="therapy.confirmed" :icon-name="'fa-check'" :color="'green'" :no-theme="true" />
            <fa-icon v-else :icon-name="'fa-xmark'" :color="'red'" :no-theme="true" />
          </div>
          <div class="span1 center">{{ therapy.qta_s }}</div>
          <div class="span2">
            {{ therapy.notes }}
            <div class="bugiardino_link royalblue">
              {{ therapy.guest_drug.before_after_meal }}
            </div>
          </div>
        </template>
        <div v-if="therapy.user" class="span2 somm_guet_activity">
          <user-media :fullname="therapy.user.full_name" :img="!isMobile && therapy.user.avatar" :datetime="therapy.updated_at" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import faIcon from '../faIcon';
import userMedia from '../userMedia';

export default {
  name: 'guestConfirmedTherapies',
  props: ['guest', 'date'],
  components: {
    userMedia,
    faIcon,
  },
  data() {
    return {
      therapies: [],
      windowWidth: window.innerWidth,
      isMobile: false,
      loading: false,
      inChange: 0,
    };
  },
  computed: {
    doneTherapies() {
      if (!this.therapies) return [];

      return this.therapies.filter((t) => t.confirmed);
    },
    allDone() {
      if (!this.therapies) return false;

      return this.doneTherapies.length == this.therapies.length;
    },
    i18nJS() {
      return window.i18nJS;
    },
    hours() {
      var hours = {};
      const teraphiesOrdered = [...this.therapies];
      teraphiesOrdered.sort(this.compareHours).forEach((therapy) => {
        if (!hours[therapy.time_description]) hours[therapy.time_description] = [];
        hours[therapy.time_description].push(therapy);
      });
      return hours;
    },
  },
  watch: {
    windowWidth: {
      immediate: true,
      handler(val) {
        this.isMobile = val <= 1000;
      },
    },
    inChange: {
      handler(newVal) {
        if (newVal > 0) {
          this.loading = true;
          if (newVal > 1) Loader.show();
        } else {
          this.loading = false;
          const done = this.therapies.filter((t) => t.confirmed).length;
          eventBus.$emit('toggleAlertTherapy', this.guest.id, done, 0);
          Loader.hide();
        }
      },
    },
    guest: {
      immediate: true,
      handler(newVal) {
        let newDate = moment(this.date, this.i18nJS.time.formats.date_only).format('YYYY-MM-DD');
        apiConnector()
          .get('/it/guest_period_data_sets/' + newVal.id + '/confirmed_therapies/' + newDate + '.json')
          .then(({ data }) => {
            this.therapies = data;
            Loader.hide();
          });
      },
    },
  },
  methods: {
    compareHours(a, b) {
      if (a.time_hour < b.time_hour) return -1;
      if (a.time_hour > b.time_hour) return 1;
      return 0;
    },
    toggleConfirmation(therapy) {
      const params = { confirmed_therapy: { notes: therapy.notes, confirmed: therapy.confirmed } };
      this.inChange += 1;
      apiConnector()
        .put('/it/confirmed_therapies/' + therapy.id + '.json', params)
        .then(({ data }) => {
          const index = this.therapies.findIndex((t) => t.id === data.id);
          this.$set(this.therapies, index, data);
          this.inChange -= 1;
        })
        .catch(() => {
          alert('Errore! Ricaricare la pagina');
          this.inChange -= 1;
        });
    },
    toggleAllConfirmation() {
      this.therapies.forEach((therapy) => {
        therapy.confirmed = $(this.$refs.checkAll).is(':checked');
        this.toggleConfirmation(therapy);
      });
    },
  },
};
</script>
<style scoped></style>
